"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALESFORCE_PREFERENCES_COPY = void 0;
exports.SALESFORCE_PREFERENCES_COPY = {
    SECTION_HEADER: 'Salesforce Preferences',
    USE_LIGHTNING_URLS: 'Use Lightning URLs'
};
//# sourceMappingURL=SALESFORCE_PREFERENCES.js.map